import RestaurantMercadoPagoTokenList from "./RestaurantMercadoPagoTokenList";
import RestaurantMercadoPagoTokenEdit from "./RestaurantMercadoPagoTokenEdit";
import RestaurantMercadoPagoTokenShow from "./RestaurantMercadoPagoTokenShow";
import RestaurantMercadoPagoTokenIcon from "@mui/icons-material/Link";

const restaurantMercadoPagoTokens = {
  list: RestaurantMercadoPagoTokenList,
  edit: RestaurantMercadoPagoTokenEdit,
  show: RestaurantMercadoPagoTokenShow,
  icon: RestaurantMercadoPagoTokenIcon,
};

export default restaurantMercadoPagoTokens;
